// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"720":"6a0d6aa2","908":"84d1fd53"}[chunkId] + ".chunk.js";
};